import React, { useState } from 'react';
import './LazyImage.css';

/**
 * LazyImage - renders with a shimmer skeleton until the image loads.
 * Uses native loading="lazy" for off-screen deferral + a fade-in on load.
 */
const LazyImage = ({ src, alt, className = '', onError, style = {} }) => {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);

    const handleLoad = () => setLoaded(true);

    const handleError = (e) => {
        setErrored(true);
        setLoaded(true); // hide skeleton
        if (onError) onError(e);
    };

    return (
        <div className={`lazy-image-wrapper ${className}`} style={style}>
            {/* Shimmer skeleton shown until image loads */}
            {!loaded && <div className="lazy-image-skeleton" aria-hidden="true" />}

            <img
                src={errored ? undefined : src}
                alt={alt}
                loading="lazy"
                decoding="async"
                onLoad={handleLoad}
                onError={handleError}
                className={`lazy-image-img${loaded ? ' lazy-image-loaded' : ''}`}
            />
        </div>
    );
};

export default LazyImage;
